/**
 * Router which shows the "home" page.
 * @module app/routers/Main
 */
import RouterBase from "app/routers/RouterBase";
import $ from "jquery";
import _ from "underscore";
import LayoutCollection from "app/models/LayoutCollection";
import MapServiceCollection from "app/models/MapServiceCollection";
import Index from "app/views/main/Index";
import Permission from "app/models/Permission";
import UserDetailView from "app/views/user/Details";
import NavigationOperations from "core/operations/NavigationOperations";
import ModelOperations from "core/operations/ModelOperations";
import User from "app/models/User";
import UserEditView from "app/views/admin/users/Edit";
import OrganizationCollection from "app/models/OrganizationCollection";
import ErrorUtils from "app/utils/ErrorUtils";
import s from "underscore.string";
import sendCreationNotification from "app/operations/send-creation-notification";
import session from "app/Session";
import page from "core/Page";
import app from "app/App";
export default RouterBase.extend({
  root: "/",
  initialize: function (options) {
    var opts = _.defaults(
      {
        layoutOptions: {
          preserve: true,
        },
      },
      options
    );

    RouterBase.prototype.initialize.call(this, opts);
  },

  firstLoad: true,

  _loadInternal: function () {
    var deferred = new $.Deferred();
    var ultimateDeferred = new $.Deferred();
    var self = this;

    function reject(deferred, modelOrCollection, xhrError) {
      deferred.reject(xhrError);
    }

    this.collection = this.collection || new LayoutCollection([]);
    this.collection.fetch({
      success: _.bind(deferred.resolve, deferred),
      error: _.partial(reject, deferred),
    });

    var deferredForServices = new $.Deferred();

    this.services = this.services || new MapServiceCollection([]);
    this.services.fetch({
      success: _.bind(deferredForServices.resolve, deferredForServices),
      error: _.partial(reject, deferredForServices),
    });

    var deferredForUser = new $.Deferred();

    if (!session.isUserLoading()) {
      Permission.clear(session.user);
      session.user.fetch({
        success: _.bind(deferredForUser.resolve, deferredForUser),
        error: _.partial(reject, deferredForUser),
      });
    } else {
      var userSuccess = function () {
        session.user.off("error", userError);
        deferredForUser.resolve();
      };

      var userError = function (err) {
        session.user.off("sync", userSuccess);
        deferredForUser.reject(err);
      };

      session.user.once("sync", userSuccess);
      session.user.once("error", userError);
    }

    $.when(
      deferred,
      deferredForServices,
      deferredForUser,
      session.queryState()
    ).then(
      function (deferredArgs, deferredForServicesArgs) {
        self.collection = deferredArgs[0];
        self.services = deferredForServicesArgs[0];
        ultimateDeferred.resolve(self.collection, self.services, session);
      },
      function (err) {
        ultimateDeferred.reject(err);
      }
    );

    return ultimateDeferred.promise();
  },

  load: function () {
    if (
      !this._loading ||
      (!this.firstLoad && this._loading.state() != "pending")
    ) {
      this._loading = this._loadInternal();
    }

    return this._loading;
  },

  routerSettings: {
    title: "Welcome",
  },

  routes: {
    "": "index",
    me: "profile",
    "me/update": "profileEdit",
    "user/:id": "user",
  },

  /**
   * Shows the home page.
   */
  index: function () {
    //refresh the collections

    var promise = this.firstLoad ? this.load() : this.reload();

    this.firstLoad = false;

    promise
      .done(
        _.bind(function () {
          if (!session.isAnonymous()) {
            //this should really never be true
            var viewOpts = {
              layouts: this.collection,
              services: this.services,
            };
            var $landingPage = $(".landing-page");
            var shouldRender = true;

            if ($landingPage.length) {
              //page was rendered server-side
              shouldRender = false;
              viewOpts.el = $landingPage.parent()[0];
            } else {
              this.layoutOptions = {};
            }

            var view = this._view || new Index(viewOpts);

            if (shouldRender) {
              view.render();
              this.doneLoading();
              app.pushView(view);
            }

            this._view = view;
          }
        }, this)
      )
      .fail(ErrorUtils.errorHandler());
  },

  _showUser: function (id) {
    var model = new User({
      id: id,
    });
    var self = this;

    model.fetch({
      success: function (model) {
        var view = new UserDetailView({
          model: model,
        });
        var rerender = function rerender() {
          if (view) {
            view.render();
          }
        };

        rerender();

        app.registerNavigationAction("back");

        if (session.user.id == id || session.hasRole("admin")) {
          app.registerItemAction(
            NavigationOperations.createNavigationOperation(
              "Edit",
              "pencil",
              "me/update",
              true
            )
          );
          app.registerItemAction(sendCreationNotification, model);

          sendCreationNotification.on(sendCreationNotification.id, rerender);
          self.once("leave", function () {
            sendCreationNotification.off(sendCreationNotification.id, rerender);
          });
        }

        app.pushView(view);
      },
      error: ErrorUtils.apiHandler({
        activity: "loading user information",
      }),
    });
  },

  user: function (id) {
    this._showUser(id);
  },

  profile: function () {
    this._showUser(session.user.id);
  },

  profileEdit: function () {
    var model = new User({
      id: session.user.id,
    });
    var organizations = new OrganizationCollection([]);
    var self = this;

    organizations.fetch({
      success: function (organizations) {
        model.fetch({
          success: function (model) {
            var view = new UserEditView({
              organizations: organizations.models,
              model: model,
            });

            self.doneLoading();
            view.render();

            app.registerNavigationAction("back");

            if (session.hasRole("admin")) {
              app.registerItemAction(
                ModelOperations.destroy("User", organizations),
                model
              );
            }

            app.registerItemAction(ModelOperations.save("User", view), model);

            app.setLayout("Wide").done(function () {
              app.pushView(view);
              _.delay(_.bind(view.delegateEvents, view), 1000);
            });
          },
          error: ErrorUtils.apiHandler({
            activity: "loading your profile",
          }),
        });
      },
      error: ErrorUtils.apiHandler({
        activity: "loading the organization list",
      }),
    });
  },
});



//////////////////
// WEBPACK FOOTER
// ./public/js/app/routers/Main.js
// module id = 938
// module chunks = 1